import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ModeOnboarding from "@/widgets/modeOnboarding/components/ModeOnboarding";
import ProjectCreation from "@/widgets/projectCreation/components/ProjectCreation";
import { WidgetsWrapper } from "@/widgets/WidgetsWrapper/WidgetsWrapper";
import { HOST_MODES } from "@/constants";
import LandingSection from "@/widgets/landing/components/LandingSection";
import LoadingAnimationHands from "@/assets/animations/loadingAnimationHands.json";
import Lottie from "react-lottie-player";
import DriveModeTool from "@/widgets/driveMode/components/DriveModeTool";
import { useMainLayoutStore } from "@/shared/zustand/mainLayoutStore";
import JiraModeTool from "@/widgets/jiraMode/components/JiraModeTool";
import EmailModeTool from "@/widgets/emailMode/components/EmailModeTool";
const ModeSwitcher = ({ loading, handleCloseModeOnboarding, setRemoteLoadedInfo, hasProject, addModeToHistory, setHostLoadedInfo, 
// activeStep,
// setActiveStep,
setStreamingMessages, isUserOnboarded, setIsUserOnboarded, }) => {
    // const { onboardingStep, setOnboardingStep } = useAuthStore()
    const { modesHistory } = useMainLayoutStore();
    const lastOpenedMode = modesHistory[modesHistory.length - 1]?.mode;
    return loading ? (_jsx("div", { className: "w-full h-full m-auto flex flex-col justify-center items-center p-6", children: _jsx(Lottie, { animationData: LoadingAnimationHands, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }) })) : (_jsxs("div", { className: "w-full max-w-[100%] h-full overflow-auto relative", children: [!lastOpenedMode && (_jsx(LandingSection
            // setCurrentHostMode={setCurrentHostMode}
            , { 
                // setCurrentHostMode={setCurrentHostMode}
                addModeToHistory: addModeToHistory, 
                // activeStep={activeStep}
                // setActiveStep={setActiveStep}
                setStreamingMessages: setStreamingMessages, isUserOnboarded: isUserOnboarded, setIsUserOnboarded: setIsUserOnboarded })), lastOpenedMode === HOST_MODES["Mode Onboarding"] && (_jsx(ModeOnboarding, { handleCloseModeOnboarding: handleCloseModeOnboarding })), lastOpenedMode === HOST_MODES["Project Mode"] && (_jsx(ProjectCreation, { setHostLoadedInfo: setHostLoadedInfo })), lastOpenedMode === HOST_MODES["Drive Mode"] && (_jsx(DriveModeTool, { setHostLoadedInfo: setHostLoadedInfo })), lastOpenedMode === HOST_MODES["Jira Mode"] && (_jsx(JiraModeTool, { setHostLoadedInfo: setHostLoadedInfo })), lastOpenedMode === HOST_MODES["Email Mode"] && (_jsx(EmailModeTool, { setHostLoadedInfo: setHostLoadedInfo })), lastOpenedMode &&
                lastOpenedMode !== HOST_MODES["Mode Onboarding"] &&
                lastOpenedMode !== HOST_MODES["Project Mode"] &&
                lastOpenedMode !== HOST_MODES["Jira Mode"] &&
                lastOpenedMode !== HOST_MODES["Drive Mode"] &&
                lastOpenedMode !== HOST_MODES["Email Mode"] && (
            // <div className="h-[85vh] max-h-[85vh] overflow-auto bg-white">
            _jsx("div", { className: "h-full overflow-auto bg-white border-t-0 border-[#d5d1db]", children: _jsx(WidgetsWrapper
                // modeList={modeList}
                // activeMode={activeMode}
                // isRemoteLoaded={isRemoteLoaded} // not used anywhere
                // setIsRemoteLoaded={setIsRemoteLoaded}  // old code
                , { 
                    // modeList={modeList}
                    // activeMode={activeMode}
                    // isRemoteLoaded={isRemoteLoaded} // not used anywhere
                    // setIsRemoteLoaded={setIsRemoteLoaded}  // old code
                    setRemoteLoadedInfo: setRemoteLoadedInfo, hasProject: hasProject }) }))] }));
};
export default ModeSwitcher;
